export default __webpack_public_path__ + "static/media/logo2.2c365a87.png";